var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LeftMenu',{attrs:{"isMode":_vm.isMode}}),_c('div',{class:{
      fmContent: true,
      fmContentTwo: _vm.isMode == 'Hide',
      fmContentThree: _vm.$route.name == 'notice',
    }},[_c('NavBar',{attrs:{"isMode":_vm.isMode}}),_c('div',{class:{
        fmGFans: true,
        fmGfansNote: _vm.$route.name == 'notice',
      }},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[(_vm.$store.state.isapp == 1 && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),(_vm.$store.state.isapp == 0)?_c('NotCenter'):_vm._e(),_c('fmDownload'),_c('RightMenu',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowRightMenu),expression:"shouldShowRightMenu"}],attrs:{"isMode":_vm.isMode}})],1)],1),_c('div',{class:{
      backTop: true,
      backTopTwo: _vm.isMode == 'leftHide',
      backTopThree: _vm.isMode == 'rightHide' || _vm.isMode == 'Hide',
      show: _vm.showBackTop,
    },on:{"click":_vm.scrollToTop}},[_c('svg-btn',{staticClass:"icon",attrs:{"icon-class":"icon-top"}})],1),_c('LoginTip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }